// eslint-disable max-len
// eslint-disable global-require
// eslint-disable-next-line import/prefer-default-export

function faqMedia(relativePath) {
  const path = String(relativePath).replace(/^\//, '');
  const onViteDevHost =
    import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    window.location.port === '5173';
  if (onViteDevHost) {
    const base = import.meta.env.BASE_URL || '/';
    const prefix = base.endsWith('/') ? base : `${base}/`;
    return `${prefix}${path}`;
  }
  return `/mobile-pass-v4/${path}`;
}

export function questions(offer, isMobile) {
  return [
    ...[
      isMobile !== 'desktop'
        ? {
            category: 'mobile',
            code: 'how-to-add-pass-to-my-phone',
            question: 'How do I add the pass to my phone?',
            icon: 'ios',
            ios: [
              {
                sectionTitle: 'Safari',
                minIosVersion: 26,
                browsers: ['safari'],
                steps: [
                  {
                    step: 'Step 1',
                    header: 'Tap \u22EF to open the Safari menu.',
                    message:
                      'If you don\'t see the icon, scroll and it should appear next to the search bar.',
                    media:
                      faqMedia('images/addtohomescreen/ios26-safari-step1.png')
                  },
                  {
                    step: 'Step 2',
                    header: 'Tap Share (box with an up arrow).',
                    media:
                      faqMedia('images/addtohomescreen/ios26-safari-step2.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Scroll down and tap "Add to Home Screen."',
                    media:
                      faqMedia('images/addtohomescreen/ios26-safari-step3.png')
                  },
                  {
                    step: 'Step 4',
                    header: 'Rename the app and select "Add."',
                    media:
                      faqMedia('images/addtohomescreen/ios26-safari-step4.png')
                  },
                  {
                    step: 'Step 5',
                    header:
                      'Now your pass will show on your Home Screen just like all your other apps!',
                    media:
                      faqMedia('images/addtohomescreen/ios26-final.png')
                  }
                ]
              },
              {
                sectionTitle: 'Chrome, Firefox, Opera',
                minIosVersion: 26,
                browsers: ['chrome', 'firefox', 'opera'],
                steps: [
                  {
                    step: 'Step 1',
                    header:
                      'Tap Share (box with an up arrow) to open the browser\'s menu.',
                    message:
                      'If you don\'t see the icon, scroll and it should appear next to the search bar.',
                    media:
                      faqMedia('images/addtohomescreen/ios26-chrome-step1.png')
                  },
                  {
                    step: 'Step 2',
                    header: 'Tap "More" (\u22EF).',
                    media:
                      faqMedia('images/addtohomescreen/ios26-chrome-step2.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Scroll down and tap "Add to Home Screen."',
                    media:
                      faqMedia('images/addtohomescreen/ios26-chrome-step3.png')
                  },
                  {
                    step: 'Step 4',
                    header: 'Rename the app and select "Add."',
                    media:
                      faqMedia('images/addtohomescreen/ios26-chrome-step4.png')
                  },
                  {
                    step: 'Step 5',
                    header:
                      'Now your pass will show on your Home Screen just like all your other apps!',
                    media:
                      faqMedia('images/addtohomescreen/ios26-final.png')
                  }
                ]
              },
              {
                sectionTitle: 'Safari',
                maxIosVersion: 25,
                steps: [
                  {
                    step: 'Step 1',
                    header: 'Click to open the Safari share menu.',
                    message:
                      'If you don\'t see the icon, scroll up and it should appear at the bottom of your screen. (Please note: If your default browser is not Safari, you will need to open this pass in Safari in order for this to work.)',
                    media:
                      faqMedia('images/addtohomescreen/step1-homescreen-ios.png')
                  },
                  {
                    step: 'Step 2',
                    header:
                      'Scroll down and click on "Add to Home Screen."',
                    media:
                      faqMedia('images/addtohomescreen/step2-homescreen-ios.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Rename the app and select "Add."',
                    media:
                      faqMedia('images/addtohomescreen/step3-homescreen-ios.png')
                  },
                  {
                    step: 'Step 4',
                    header:
                      'Now your pass will show on your Home Screen just like all of your other apps!',
                    media:
                      faqMedia('images/addtohomescreen/step4-homescreen-ios.png')
                  }
                ]
              }
            ],
            android: [
              {
                sectionTitle: 'Chrome',
                browsers: ['chrome'],
                steps: [
                  {
                    step: 'Step 1',
                    header:
                      'To the right of the address bar, tap More ( \u22EE ) to open the Chrome menu.',
                    message:
                      'If you don\'t see the icon, scroll and it should appear next to the search bar.',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step1.png')
                  },
                  {
                    step: 'Step 2',
                    header:
                      'Scroll down and tap "Add to home screen" or "Install App."',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step2.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Select "Install" or "Create Shortcut."',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step3.png')
                  },
                  {
                    step: 'Step 4',
                    header:
                      'Rename the app if you like and confirm "Add" or "Install."',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step4.png')
                  },
                  {
                    step: 'Step 5',
                    header:
                      'Tap and hold on the icon to arrange it where you would like, or simply select "Add."',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step5.png')
                  },
                  {
                    step: 'Step 6',
                    header:
                      'Now your pass will show on your Home Screen just like all your other apps!',
                    media:
                      faqMedia('images/addtohomescreen/android-chrome-step6.png')
                  }
                ]
              },
              {
                sectionTitle: 'Firefox',
                browsers: ['firefox'],
                steps: [
                  {
                    step: 'Step 1',
                    header:
                      'Tap the menu button ( \u22EE ) to open the browser\'s menu.',
                    message:
                      'If you don\'t see the icon, scroll and it should appear at the bottom (or top) of the screen next to the search bar.',
                    media:
                      faqMedia('images/addtohomescreen/android-firefox-step1.png')
                  },
                  {
                    step: 'Step 2',
                    header:
                      'Scroll down and tap "Add to Home Screen."',
                    media:
                      faqMedia('images/addtohomescreen/android-firefox-step2.png')
                  },
                  {
                    step: 'Step 3',
                    header:
                      'Rename the app if you like and tap "Add."',
                    media:
                      faqMedia('images/addtohomescreen/android-firefox-step3.png')
                  },
                  {
                    step: 'Step 4',
                    header:
                      'Tap and hold the icon to drag it to your desired position, or tap "Add."',
                    media:
                      faqMedia('images/addtohomescreen/android-firefox-step4.png')
                  },
                  {
                    step: 'Step 5',
                    header:
                      'Now your pass will show on your Home Screen just like all your other apps!',
                    media:
                      faqMedia('images/addtohomescreen/android-firefox-step5.png')
                  }
                ]
              }
            ]
          }
        : null
    ],
    ...[
      isMobile !== 'desktop'
        ? {
            question: 'How do I enable location services?',
            code: 'how-to-enable-location-services',
            category: 'mobile',
            icon: 'ios',
            ios: [
              {
                steps: [
                  {
                    step: 'Step 1',
                    header: 'Open the "Settings" app.',
                    media: faqMedia('images/location/step1-location-ios.png')
                  },
                  {
                    step: 'Step 2',
                    header: 'Scroll down and select "Privacy."',
                    media: faqMedia('images/location/step2-location-ios.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Select "Location Services."',
                    media: faqMedia('images/location/step3-location-ios.png')
                  },
                  {
                    step: 'Step 4',
                    header: 'Ensure "Location Service" is turned on',
                    media: faqMedia('images/location/step4-location-ios.png')
                  },
                  {
                    step: 'Step 5',
                    header: 'Scroll down and select "Safari Websites."',
                    media: faqMedia('images/location/step5-location-ios.png')
                  },
                  {
                    step: 'Step 6',
                    header: 'Select "While Using the App."',
                    media: faqMedia('images/location/step6-location-ios.png')
                  }
                ]
              }
            ],
            android: [
              {
                steps: [
                  {
                    step: 'Step 1',
                    header: 'Open the "Chrome" app.',
                    media:
                      faqMedia('images/location/step1-location-android.png')
                  },
                  {
                    step: 'Step 2',
                    header: 'Click \u22EE to open the "Chrome" menu.',
                    media:
                      faqMedia('images/location/step2-location-android.png')
                  },
                  {
                    step: 'Step 3',
                    header: 'Click on "Settings."',
                    media:
                      faqMedia('images/location/step3-location-android.png')
                  },
                  {
                    step: 'Step 4',
                    header: 'Click on "Site settings."',
                    media:
                      faqMedia('images/location/step4-location-android.png')
                  },
                  {
                    step: 'Step 5',
                    header: 'Click on "Location."',
                    media:
                      faqMedia('images/location/step5-location-android.png')
                  },
                  {
                    step: 'Step 6',
                    header: 'Ensure the toggle switch is in the "On" position.',
                    media:
                      faqMedia('images/location/step6-location-android.png')
                  }
                ]
              }
            ]
          }
        : null
    ]
  ];
}
